real.window = (function($, real) {
    'use strict';

    let windowIsUnloading = false;
    let listeningToModalClose = false;

    const reloadAsSoonAsPossible = (checkIdle = true) => {
        // If not yet listening for modals closing -> start listening now.
        if (!listeningToModalClose && typeof howspace.components.modal !== 'undefined') {
            listeningToModalClose = true;
            real.dom.$body.on(howspace.components.modal.MODAL_CLOSED, () => {
                setTimeout(real.window.reloadAsSoonAsPossible, 100);
            });
        }

        // Let's check if user is busy doing "something" which we would interrupt by reloading the page.
        if ($('.modal:visible').length > 0) {
            // User has a modal open, do not reload.
            return false;
        }

        if ($('#live-popout-layout iframe').length > 0) {
            // User is in a live meeting, do not reload.
            return false;
        }

        if ($('.video-js-initialized.playing').length > 0) {
            // User is playing video, do not reload.
            return false;
        }

        if ($('.audio-js-initialized.playing').length > 0) {
            // User is playing audio, do not reload.
            return false;
        }

        if ($('.btn-success:visible:not(.disabled, [disabled])').length > 0) {
            // User has a non-disabled "success" button visible on the screen. So user is doing
            // some changes that need to be saved by clicking a button. Do not reload.
            return false;
        }

        if (!document.hasFocus()) {
            // Document does not have focus, let's wait until window receives focus before reloading the window.
            window.addEventListener('focus', () => {
                window.location.reload();
            });
            return false;
        }

        if (checkIdle && howspace.activityTracker.isIdle()) {
            // User is idle, do not reload.
            return false;
        }

        // Document has focus, let's reload the window.
        window.location.reload();
        return true;
    };

    window.addEventListener('beforeunload', function(e) {
        windowIsUnloading = true;
    });

    return {
        isUnloading : function() {
            return windowIsUnloading;
        },

        reloadAsSoonAsPossible : reloadAsSoonAsPossible,

        getReloadBtn : function() {
            return `<button class="btn btn-tertiary p-2 reload-btn">
                    <i class="fa-light fa-arrows-rotate-reverse"></i>
                    <span class="btn-text">${howspace.translate('layout_reload_this_page')}</span>
                </button>`;
        },

        reloadPageOrNotifyUser : function(message, checkIdle) {
            if (reloadAsSoonAsPossible(checkIdle)) {
                return;
            }

            // User is busy doing something, cannot reload the page.
            if ($('#live-popout-layout iframe').length > 0) {
                // User is in a live meeting, do not show the notification.
                return false;
            }

            // Show a notification.
            const reloadBtn = `<button class="btn btn-tertiary p-2 reload-btn">
                <i class="fa-light fa-arrows-rotate-reverse"></i>
                <span class="btn-text">${howspace.translate('layout_reload_this_page')}</span>
            </button>`;
            const text = message + ' ' + reloadBtn;

            const notification = real.notification.show(text, 'success', false);
            notification.on('click', '.reload-btn', function(e) {
                notification.off('click', '.reload-btn');
                window.location.reload();
            });
        },
    }
})(jQuery, real);
